/** Admin: attendant role definitions for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import RolesScreen from '../../../../owner/staff/roles';

export default function AdminOwnerStaffRolesScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <RolesScreen />
    </OwnerScopeProvider>
  );
}
